import { Controller } from "@hotwired/stimulus";

export default class LinkController extends Controller {
  static targets = ["item"];
  static values = { mode: String };

  click(event) {
    const clickedLink = event.currentTarget;

    if (this.modeValue === "toggle") {
      // Toggle mode: individual items can be toggled on/off (for tags)
      if (clickedLink.classList.contains("bg-[#FF5286]")) {
        // Currently active, remove active styling
        clickedLink.classList.remove("bg-[#FF5286]", "text-white");
        clickedLink.classList.add("bg-gray-100", "text-gray-700");
      } else {
        // Currently inactive, add active styling
        clickedLink.classList.remove("bg-gray-100", "text-gray-700");
        clickedLink.classList.add("bg-[#FF5286]", "text-white");
      }
    } else {
      // Default mode: mutual exclusion (for navbar)
      // Remove active class from all links
      this.itemTargets.forEach((link) => {
        link.classList.remove("!bg-[#FF5286]");
      });

      // Add active class to clicked link optimistically
      clickedLink.classList.add("!bg-[#FF5286]");
    }
  }
}
